import { apiConfig } from '../../dashboard-config/dashboard-config.js';

export default () => ({
  baseUrlApi: apiConfig.baseUrlApi,
  baseUrlApiDvg: apiConfig.baseUrlApiDvg,
  baseUrlContentApi: apiConfig.baseUrlContentApi,
  baseUrlHohSearchEngine: apiConfig.baseUrlHohSearchEngine,
  config: {
    env: process.env.NODE_ENV,
    keycloak: {
      token: null,
      refreshToken: null,
      kc: null
    },
    userObject: null,
    isTokenExpiredFn: null,
    loader: {
      show: false,
      text: null
    },
    snackbar: {
      open: false,
      text: null,
      showCloseButton: false,
      timeout: 4000,
      color: 'info'
    },
    customComponentsConfig: {},
    customDashboardConfig: {}
  }
});
